import PersonalInfoCardComponent from './PersonalInfoCardContainer';

export default PersonalInfoCardComponent;
